import Axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import Spinner from "../../../components/Spinner/Spinner";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import * as actions from "../../../store/actions/index";
import Workouts from "./Workouts/Workouts";

class AddPlanForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      url: "",
      workoutPlan: {
        title: "",
        // categoryName: "",
        desc: "",
        // workouts: [],
      },
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleWorkoutChange = this.handleWorkoutChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddWorkout = this.handleAddWorkout.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    this.props.fetchWorkoutPlans();
    this.props.onFetchCategory();
  }

  handleChange(e) {
    const { name, value } = e.target;
    let workoutPlan = { ...this.state.workoutPlan };
    workoutPlan[name] = value;
    this.setState({ workoutPlan: workoutPlan });
  }

  handleWorkoutChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();
    // console.log("Workout Plan",this.state.workoutPlan);
    this.props.addWorkoutPlan(this.state.workoutPlan,this.props.workouts)
  }

  handleAddWorkout(e) {
    e.preventDefault();
    let workout = {
      title: this.state.title,
      url: this.state.url,
    };
    let workoutArray = this.state.workoutPlan.workouts;
    workoutArray.push(workout);
    this.setState({ workoutArray: workoutArray });
    console.log(workoutArray);
  }

  handleRemove(e, workout) {
    e.preventDefault();
    console.log(workout);
  }

  render() {
    let plans = this.props.workouts;
    return (
      <React.Fragment>
        <h3 className="text-center">Workout Plans Management</h3>
        <hr />
        <form onSubmit={this.handleSubmit}>
          <div className="row mx-4">
            <div class="form-group col-md-3">
              <label for="workoutTitle">Title</label>
              <input
                name="title"
                type="text"
                id="workoutTitle"
                className="form-control"
                onChange={this.handleChange}
                placeholder="Enter Workout Title"
                value={this.state.workoutPlan.title}
                required
              />
            </div>
            {/* <div class="form-group col-md-3">
              <label for="inlineFormSelCategory">Category</label>
              <select
                name="categoryName"
                className="custom-select my-1 mr-sm-2"
                id="inlineFormSelCategory"
                value={this.state.workoutPlan.categoryName}
                onChange={this.handleChange}
                required
              >
                <option value="">Select...</option>
                {this.props.categories &&
                  this.props.categories.map((category, index) => (
                    <option
                      key={index}
                      value={category.categoryName}
                      name="categoryName"
                    >
                      {category.categoryName}
                    </option>
                  ))}
              </select>
            </div> */}




    





            <div class="form-group col-md-4">
              <label for="Description">Description</label>
              <textarea
                name="desc"
                type="text"
                id="Description"
                className="form-control"
                placeholder="Description"
                onChange={this.handleChange}
                value={this.state.workoutPlan.desc}
                rows="3"
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-sm btn-success d-inline"
              style={{ marginTop: "5rem", marginBottom: "2rem" }}
              disabled={this.props.addPlanLoading}
            >
              {this.props.addPlanLoading ? "Saving" : "Save"}
            </button>
          </div>
        </form>
        <hr /> 
        {!this.props.loading ? (
          plans.map((plan, index) => <Workouts plan={plan} index={index} />)
        ) : (
          <Spinner />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    categories: state.category.categories,
    workouts: state.workouts.workouts,
    loading: state.workouts.workoutsLoading,
    addPlanLoading: state.workouts.addPlanLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchWorkoutPlans: () => dispatch(actions.fetchWorkoutPlans()),
    onFetchCategory: () => dispatch(actions.fetchCategoryAdmin()),
    addWorkoutPlan:(plan,workouts_plans)=>dispatch(actions.addWorkoutPlan(plan,workouts_plans))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(AddPlanForm, Axios));
